import React from 'react'
import storkImage from '../../../assets/img/author_stork.svg'
import authorImage from '../../../assets/img/author.svg'

const AuthorTablet: React.FC = () => {
  return (
    <section className="w-full min-h-[90vh] bg-black text-white pb-[400px] py-16 flex items-center justify-center relative overflow-visible">
      {/* Author Content */}
      <div className="w-full max-w-6xl flex flex-col items-center relative z-10">
        <h1 className="font-apropal text-[64px] text-white font-bold mb-4 text-center w-full">
          Autor
        </h1>
        
        <p className="text-white mb-4 w-1/2">
        Krzysztof Kruk swoją twórczością chce przekazać myśl o tym, że życie jest piękne. 
        </p>
        
        <p className="text-white mb-4 w-1/2">
        Ta prosta idea towarzyszyła mu zawsze, także w trakcie poszukiwania swojej drogi zawodowej – zaczynając od robienia kawy w kawiarni, przez pracę na budowie, studia w Polsce i Danii, a kończąc na sześcioletniej karierze programisty.
        </p>
        <p className="text-white mb-4 w-1/2">
        W literaturze dziecięcej w końcu znalazł swoje miejsce. "Zuchy" to jego debiut, który narodził się po czterech latach prób i poszukiwań.
        </p>
      </div>
    
     {/* Stork Illustration */}
      <div className="absolute bottom-[-5%] max-h-[400px] w-[30%] left-[5%] w-2/5 z-50 opacity-100">
        <img 
          src={storkImage} 
          alt="Stork illustration" 
          className="w-full h-full object-contain"
        />
      </div>


      {/* Author Image */}
      <div className="absolute bottom-0 right-0 w-[310px] h-auto z-10">
        <img 
          src={authorImage} 
          alt="Author portrait" 
          className="w-full h-full object-cover"
        />
      </div>
    </section>
  )
}

export default AuthorTablet